import store from '@/store/index.js';
import { userActionTypes, userGetterTypes } from '@/store/modules/user.js';
import { developmentCentersGetterTypes } from '@/admin/store/modules/developmentCenters/getters.js';
import { developmentCentersActionTypes } from '@/admin/store/modules/developmentCenters/actions.js';

export const authAndCenterIdGuard = async (to, _from, next) => {
    if (!store.getters[`user/${userGetterTypes.GET_USER}`].name) await store.dispatch(`user/${userActionTypes.GET_USER}`);

    if (!store.getters[`developmentCenters/${developmentCentersGetterTypes.GET_DEVELOPMENT_CENTERS}`]?.length) {
        await store.dispatch(`developmentCenters/${developmentCentersActionTypes.FETCH_DEVELOPMENT_CENTERS}`);
    }

    if (!store.getters[`developmentCenters/${developmentCentersGetterTypes.GET_SELECTED_DEVELOPMENT_CENTER}`]?.length) {
        await store.dispatch(`developmentCenters/${developmentCentersActionTypes.FETCH_SELECTED_DEVELOPMENT_CENTER}`);
    }

    const developmentCenterId = to.params.developmentCenterId ??
        store.getters[`developmentCenters/${developmentCentersGetterTypes.GET_SELECTED_DEVELOPMENT_CENTER}`]?.id ??
        store.getters[`developmentCenters/${developmentCentersGetterTypes.GET_DEVELOPMENT_CENTERS}`][0]?.id ??
        '0';

    const user = store.getters[`user/${userGetterTypes.GET_USER}`];
    const isDefaultUser = !user.has_dc_access;

    if (isDefaultUser) next({ name: 'NotAvailable' });

    if (Number(to.params.developmentCenterId) === 0) {
        next({ name: 'NotAvailable' });
    } else if (to.params.developmentCenterId) {
        next();
    } else {
        next({
            ...to,
            params: {
                ...to.params,
                developmentCenterId,
            },
        });
    }
};
